import { CircleHelp } from '@parrot-software/design-system/icons';

interface PrimaryHeaderProps {
  title: string;
  description: string;
  showHelpIcon?: boolean;
}

/**
 * Primary Header Component
 *
 * Top-level header for major sections (e.g., "Personal")
 * Larger font size and higher visual hierarchy
 *
 * @param {PrimaryHeaderProps} props - Component properties
 * @param {string} props.title - Section title
 * @param {string} props.description - Section description
 * @param {boolean} [props.showHelpIcon=true] - Whether to show help icon
 * @returns {React.ReactElement} Primary header component
 *
 * @example
 * <PrimaryHeader
 *   title="Personal"
 *   description="Crea roles y usuarios para definir accesos..."
 * />
 */
export const PrimaryHeader = ({ title, description, showHelpIcon = false }: PrimaryHeaderProps): React.ReactElement => {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-bold text-foreground">{title}</h1>
        {showHelpIcon && <CircleHelp className="size-5 text-muted-foreground cursor-help" />}
      </div>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
};
